/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { MedicalAssessMent } from 'app/shared/model/enumerations/medical-assess-ment.model';
import { MedicalCondition } from 'app/shared/model/enumerations/medical-condition.model';

export interface IPreOpAddlAssessment {
  id?: string;
  history?: string | null;
  clinicalFindings?: string | null;
  specificInvestigations?: string | null;
  medicalAssessment?: keyof typeof MedicalAssessMent | null;
  medicalAssessmentNotes?: string | null;
  medicalCondition?: keyof typeof MedicalCondition | null;
  medicalConditionNotes?: string | null;
  instructions?: string | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  surgery?: IPatientProcedure;
  reviewedBy?: IDoctor;
}

export const defaultValue: Readonly<IPreOpAddlAssessment> = {
  active: false,
};
